// eslint-disable-next-line @nx/enforce-module-boundaries
import { TSystemUsageViewType } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';
import { TTableCellTree, TTableOptions } from '../../table.type';

export const SYSTEM_USAGE_TABLE_MODEL = {
  createModel: (config: TSystemUsageViewType['view_spec']['columns'], data: any) => {
    return ModifiersZTableModel.createTableModel(
      data,
      {
        headerConfig: SYSTEM_USAGE_TABLE_MODEL.createHeaderConfig(config) as TTableOptions['headerConfig'],
        sort: true,
      },
      (item: any) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            ...config
              .filter((_) => _.prop !== 'action')
              .map((cell) => ({
                type: 'TEXT_CELL',
                text: item[cell.prop],
                align: 'start',
              })),
            {
              type: 'ACTION_CELL',
              actionType: 'CHART',
              asIcon: true,
            },
          ] as TTableCellTree[],
        };
      },
    );
  },
  createHeaderConfig: (config: TSystemUsageViewType['view_spec']['columns']) => {
    return config.map((cell) =>
      cell.prop === 'action'
        ? {
            type: 'ACTION_CELL',
            text: 'View Chart',
            stickyType: 'RIGHT',
            widthInPx: 32,
          }
        : {
            type: 'TEXT_CELL',
            text: cell.name,
          },
    );
  },
};
